<template>
  <div
    class="page m"
    id="m-page"
    :class="{
      unscroll: (!canLanscape && isLandscape) || (!canVertical && !isLandscape),
      landscape: isLandscape
    }"
  >
    <!-- 竖屏提示 -->
    <div class="orientation" v-if="!canLanscape" v-show="isLandscape">
      <em class="icon"></em>
      <p class="tips">{{ letter.landscapeTip }}</p>
    </div>
    <!-- 横屏提示 -->
    <div
      class="orientation orientation1"
      v-if="!canVertical"
      v-show="!isLandscape"
    >
      <em class="icon"></em>
      <p class="tips">{{ letter.h5_verticalTip }}</p>
    </div>
    <Bg v-if="!isThirdPlatform && canLanscape"></Bg>
    <GameIframe v-if="!isThirdPlatform"></GameIframe>
    <MobageIframe v-if="thirdPlatformType === 'mobage'"></MobageIframe>
    <DanaIframe v-if="thirdPlatformType === 'dana'"></DanaIframe>
    <TiktokIframe v-if="thirdPlatformType === 'tiktok'"></TiktokIframe>
    <!-- 2021-11-19 冯嘉妍
    1、登录之后，因为研发的页面没有事件冒泡，因此页面无法滚动（底部不可见）。
    2、由于页面大于100%，在游戏内点开输入框之后，部分安卓会为了在打开键盘的时候能看到输入框而滚动页面，但关闭之后没有滚回原位
    3、由于1，玩家无法通过滚动游戏界面回到最上，导致游戏页面显示不全
    4、以上，暂将移动端底部设为：仅无登录态时显示（于原效果基本一致） -->
    <template v-if="!isThirdPlatform && isFooter && !userId">
      <FooterSlfuntapVn v-if="footerState == 'slfuntapVn'"></FooterSlfuntapVn>
      <FooterHhgamesVn v-else-if="footerState == 'hhgamesVn'"></FooterHhgamesVn>
      <FooterCommonGlobal
        v-else-if="(isGlobal && !footerState) || footerState == 'commonGlobal'"
      ></FooterCommonGlobal>
      <FooterCommonGm99
        v-else-if="(isGm99 && !footerState) || footerState == 'commonGm99'"
      ></FooterCommonGm99>
    </template>
    <AgePopup v-if="!isThirdPlatform && agePopupState"></AgePopup>
    <VerifiedPopup v-if="verifiedPopupState"></VerifiedPopup>
    <transition name="fade">
      <SafariPwaGuidePopup
        v-if="isGuide"
        @close="hideSafariTip"
      ></SafariPwaGuidePopup>
    </transition>
    <transition name="fade">
      <PwaGuidePopup
        v-if="isPwaGuide"
        @install="guideInstall"
        @close="hidePwaGuide"
      ></PwaGuidePopup>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SafariPwaGuidePopup from '../components/commission/SafariPwaGuidePopup'
import PwaGuidePopup from '../components/commission/PwaGuidePopup'
import GameIframe from '../components/GameIframe'
import MobageIframe from '../components/MobageIframe'
import DanaIframe from '../components/DanaIframe.vue'
import TiktokIframe from '../components/TiktokIframe'
import FooterCommonGlobal from '../components/commission/FooterCommonGlobal'
import FooterSlfuntapVn from '../components/commission/FooterSlfuntapVn'
import FooterCommonGm99 from '../components/commission/FooterCommonGm99'
import FooterHhgamesVn from '../components/commission/FooterHhgamesVn'
import Bg from '../components/Bg'
import Platform from '../mixins/Platform'
import AgePopup from '../components/AgePopup'
import globalConfig from '../utiles/globalConfig'
import { scrollTop } from '../utiles/index'
import VerifiedPopup from '../components/VerifiedPopup'
import Exe from '../mixins/Exe'
import Pwa from '../mixins/Pwa'
export default {
  name: 'mobile',
  data() {
    return {
      isLandscape: false,
      isFooter: window.pageInfo.footer,
      canLanscape: window.pageInfo['isLandscape'],
      canVertical: window.pageInfo['isVertical'],
      footerState:
        window.pageInfo['footerType'][window.h5ip] ||
        window.pageInfo['footerType'][this.lang] ||
        window.pageInfo['footerType'].default ||
        ''
    }
  },
  mixins: [Platform, Exe, Pwa],
  computed: {
    ...mapGetters([
      'thirdPlatformType',
      'letter',
      'favourSelecePopupState',
      'agePopupState',
      'userId',
      'verifiedPopupState',
      'gclid',
      'cid',
      'scid'
    ])
  },
  components: {
    SafariPwaGuidePopup,
    PwaGuidePopup,
    GameIframe,
    MobageIframe,
    DanaIframe,
    TiktokIframe,
    FooterCommonGlobal,
    FooterSlfuntapVn,
    FooterHhgamesVn,
    FooterCommonGm99,
    AgePopup,
    Bg,
    VerifiedPopup
  },
  beforeCreate() {
    this.$nextTick(() => {
      this.isLandscape =
        typeof window.orientation === 'number'
          ? window.orientation !== 0
          : window.innerWidth > window.innerHeight
      // this.isLandscape =
      //   typeof window.orientation === "number" && window.orientation !== 0;
    })
  },
  mounted() {
    globalConfig.addEvenListener(() => {
      if (typeof window.orientation === 'number') {
        this.isLandscape = window.orientation !== 0
      }
      scrollTop()
      setTimeout(() => {
        if (!typeof window.orientation === 'number') {
          this.isLandscape = window.innerWidth > window.innerHeight
        }
        window.initViewport(window.innerHeight)
      }, 300)
    }, 'orientationchange')
    scrollTop()
    this.banScale()
    if (this.isElectronExe) {
      window.alert = message => {
        this.exeSendToIPC('openAlert', message)
      }
      this.exeOnIPC('reloadHtmlPage', () => {
        window.location.reload()
      })
    }
  },
  created() {
    this.getCurGclid().then(() => {
      globalConfig.ajaxStatistics({
        eventName: 'launch',
        eventType: 'custom_loss',
        cid: this.cid,
        gclid: this.gclid,
        scid: this.scid,
        fbc: this.fbc,
        fbp: this.fbp,
        adid: this.adid,
        adname: this.adname,
        camid: this.camid,
        camname: this.camname,
        adsetid: this.adsetid,
        adsetname: this.adsetname
      })
    })
  },
  methods: {
    ...mapActions(['getCurGclid']),
    banScale() {
      try {
        // 移动端手势禁止：主要是为了禁止放大
        document.addEventListener('gesturestart', function (event) {
          event.preventDefault()
        })

        //移动端双击禁止：主要是为了禁止放大
        document.addEventListener('dblclick', function (event) {
          event.preventDefault()
        })

        document
          .getElementById('m-page')
          .addEventListener('touchmove', function (e) {
            if (e.touches.length > 1) {
              e.stopPropagation()
              e.preventDefault()
            }
          })

        //移动端快速点击禁止：主要是为了禁止放大
        let lastTouchEnd = 0
        document.addEventListener(
          'touchend',
          function (event) {
            let now = new Date().getTime()
            if (now - lastTouchEnd <= 300) {
              event.preventDefault()
            }
            lastTouchEnd = now
          },
          false
        )
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/_dimen.scss';
@import '../assets/scss/h5.scss';

.page {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  position: relative;
  &.unscroll {
    overflow-x: hidden;
    overflow-y: auto;
  }
  &.landscape {
    height: 1113vh;
    width: 750vw;
    transform: scale(0.8) translateY(-12%);
  }
}
.m {
  .popup {
    z-index: 10;
    &-content {
      width: 90%;
    }
  }
  .game-box {
    height: 100%;
  }
  // ios 小于16会自动放大页面
  .content-box .input {
    font-size: 16px;
  }
  .content-box {
    .input {
      font-size: 16px;
    }
  }
}

.orientation {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 1113vh;
  background: black;
  z-index: 100;
  text-align: center;
  .tips {
    color: white;
    font-size: 50vh;
    width: 100%;
    text-align: center;
  }
  .icon {
    background: url($img + 'orientation.png') no-repeat top center;
    background-size: contain;
    width: 800vh;
    height: 597vh;

    display: block;
    margin: 160vh auto auto;
  }
  &.orientation1 {
    .icon {
      width: 500vw;
      height: 500vw;
      background: url($img + 'orientation1.png') no-repeat top center;
      background-size: contain;
    }
    .tips {
      font-size: 30vw;
    }
  }
}
</style>
